import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Hire these interns",
  "description": "",
  "published": "2018-07-10T00:00:00.000Z",
  "redirect_from": ["/blog/hire-these-interns/swizec/8500"],
  "categories": "Freelancing, Front End, Personal, Side Projects, Technical",
  "hero": "./img/i-qOD5jH.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A few weeks ago I made an offer: `}<em parentName="p">{`Come work with me, and I'll pay you to learn React.`}</em></p>
    <p>{`20 people applied. I am not famous 🤔`}</p>
    <p>{`But I only had room for 1, so that's plenty. Now I was faced with a challenge: `}<em parentName="p">{`How do you pick 1 person out of 20 to help you code things you don't have time to code?`}</em></p>
    <p>{`The original problem I'm solving is all about time and energy – I don't have enough of either. Interviewing everyone individually was out of the question.`}</p>
    <p>{`So I designed `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/tech-intern-job/swizec/8454"
      }}>{`a sort of interview audition system`}</a>{`. Something like this:`}</p>
    <ol>
      <li parentName="ol">{`Hold a one-to-many webinar where I explain a React concept. Learning something is valuable to applicants, I hope.`}</li>
      <li parentName="ol">{`Ask for app submissions built with this concept. Building something for practice is valuable to applicants, I hope.`}</li>
      <li parentName="ol">{`Rank folks based on how fast they learn. This is based on my subjective spidey senses, I'm afraid. I don't know how to make it objective.`}</li>
    </ol>
    <p>{`Many said they don't have time for this bullshit and dropped out before the webinar. That's okay. I designed the process this way. If you don't have time to talk to me, you won't have time to work on stuff either.`}</p>
    <p>{`You might `}<em parentName="p">{`make`}</em>{` time if I could offer oodles of money or super crazy interesting problems. But I don't have either of those yet. Sorry.`}</p>
    <p>{`Some new people showed up at the webinar. That's cool, too. The more, the merrier.`}</p>
    <lite-youtube {...{
      "videoid": "zCYuhqW2Qeo",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`The webinar got 226 views. 49 while it was live.`}</p>
    <p>{`Of those, 6 sent me an app to look at. 🎉`}</p>
    <p>{`That's a conversion rate of 30%. Pretty good considering the best I can offer is a sort of intern apprenticeship with a bit of money involved.`}</p>
    <p>{`Although some folks applying had like 2 or 3 years of experience, and that's crazy. Is nobody hiring juniors anymore? 🤔`}</p>
    <h2 {...{
      "id": "heres-what-people-built"
    }}>{`Here's what people built`}</h2>
    <p>{`Here's some stuff that people built. I promised I'd share it with the world, and who knows, you might decide you need someone to help you code, too.`}</p>
    <p><a parentName="p" {...{
        "href": "mailto:judenangoli@yahoo.com"
      }}><strong parentName="a">{`Jude`}</strong></a>{` built a cool names meaning thingy. Great styling, lovely use of React context. Works great and has many buttons that show there's good ideas to go forward.`}</p>
    <p><a parentName="p" {...{
        "href": "https://test-ad62f.firebaseapp.com/"
      }}><span parentName="a" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px",
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "52.91479820627802%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'212\\'%20viewBox=\\'0%200%20400%20212\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%205v4h401V0H0v5m0%20204v3h401v-7H0v4\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/ab6201ca1adad9b2a605e82ad98899f8/ca0a1/i-qOD5jH.webp 223w", "/static/ab6201ca1adad9b2a605e82ad98899f8/75680/i-qOD5jH.webp 445w", "/static/ab6201ca1adad9b2a605e82ad98899f8/8d1ba/i-qOD5jH.webp 890w", "/static/ab6201ca1adad9b2a605e82ad98899f8/3838e/i-qOD5jH.webp 1335w", "/static/ab6201ca1adad9b2a605e82ad98899f8/e11e5/i-qOD5jH.webp 1780w", "/static/ab6201ca1adad9b2a605e82ad98899f8/8bd77/i-qOD5jH.webp 6016w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/ab6201ca1adad9b2a605e82ad98899f8/e92b6/i-qOD5jH.png 223w", "/static/ab6201ca1adad9b2a605e82ad98899f8/e66bf/i-qOD5jH.png 445w", "/static/ab6201ca1adad9b2a605e82ad98899f8/4ef49/i-qOD5jH.png 890w", "/static/ab6201ca1adad9b2a605e82ad98899f8/4e814/i-qOD5jH.png 1335w", "/static/ab6201ca1adad9b2a605e82ad98899f8/701e9/i-qOD5jH.png 1780w", "/static/ab6201ca1adad9b2a605e82ad98899f8/76585/i-qOD5jH.png 6016w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/ab6201ca1adad9b2a605e82ad98899f8/4ef49/i-qOD5jH.png",
              "alt": "i qOD5jH",
              "title": "i qOD5jH",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></a></p>
    <p><a parentName="p" {...{
        "href": "mailto:ferwee@gmail.com"
      }}><strong parentName="a">{`Frikan`}</strong></a>{` built an entire hat shop! Uses React context to share state around and works pretty well. Nice simple styling, good code behind the scenes.`}</p>
    <p><a parentName="p" {...{
        "href": "https://frikanrw.github.io/contexthatshop/"
      }}><span parentName="a" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px",
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "48.87892376681614%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'196\\'%20viewBox=\\'0%200%20400%20196\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M89%2014v9h10c9%200%2010-1%2010-3%200-6-1-7-7-7l-5%201-2%201-1-1-2-1-3%201m22%202v3h20v-6h-20v3m23%202v5h9c9%200%2010-1%2010-6%200-4%200-4-2-4l-3%201h-1l-7-1h-6v5m23-4l-1%205%201%204h19v-3c0-4%200-4-3-4l-3-1c0-2-12-3-13-1m74%201l-5%201c-3%200-3%202%200%204%202%202%204%203%204%201h1v1c-1%202%209%201%2011-1s2-3%200-5c-2-3-8-3-11-1m16%203v5h20V13h-20v5m23-4l-1%205%201%204h6l10-1h4v-8l-10-1-10%201m22%204l1%205h19V13h-20v5m-90-2v7h20v-7h-5c-6%200-6%200-6%203l-1%203-1-4c0-2%200-2-3-2h-4\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/eef6bd5c41e902bb3861871d9be591cb/ca0a1/i-u3SgS7.webp 223w", "/static/eef6bd5c41e902bb3861871d9be591cb/75680/i-u3SgS7.webp 445w", "/static/eef6bd5c41e902bb3861871d9be591cb/8d1ba/i-u3SgS7.webp 890w", "/static/eef6bd5c41e902bb3861871d9be591cb/3838e/i-u3SgS7.webp 1335w", "/static/eef6bd5c41e902bb3861871d9be591cb/e11e5/i-u3SgS7.webp 1780w", "/static/eef6bd5c41e902bb3861871d9be591cb/7e181/i-u3SgS7.webp 6008w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/eef6bd5c41e902bb3861871d9be591cb/e92b6/i-u3SgS7.png 223w", "/static/eef6bd5c41e902bb3861871d9be591cb/e66bf/i-u3SgS7.png 445w", "/static/eef6bd5c41e902bb3861871d9be591cb/4ef49/i-u3SgS7.png 890w", "/static/eef6bd5c41e902bb3861871d9be591cb/4e814/i-u3SgS7.png 1335w", "/static/eef6bd5c41e902bb3861871d9be591cb/701e9/i-u3SgS7.png 1780w", "/static/eef6bd5c41e902bb3861871d9be591cb/bb14c/i-u3SgS7.png 6008w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/eef6bd5c41e902bb3861871d9be591cb/4ef49/i-u3SgS7.png",
              "alt": "i u3SgS7",
              "title": "i u3SgS7",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></a></p>
    <p><a parentName="p" {...{
        "href": "mailto:fred.thefriedone@gmail.com"
      }}><strong parentName="a">{`Fred`}</strong></a>{` built a World Cup red/yellow card app of sorts. Helps you keep track of how many red and yellow cards your favorite players got this time around. Great idea!`}</p>
    <p><a parentName="p" {...{
        "href": "https://codesandbox.io/s/8kvnzq98p8"
      }}><span parentName="a" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px",
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "67.2645739910314%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'269\\'%20viewBox=\\'0%200%20400%20269\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20135v134h401V0H0v135M201%207l3%202h2l1%201h2l2%201%202%202%203%202%201%202%201%202%202%205c0%205%200%205-2%203-3-2-15-3-22-1l-10%202-7%201-4%201-1%202-1%202c-1-1-7%207-8%2011s-6%2015-8%2016c-1%202-2%2060-1%2061l54%201h34V97l-3-2-12-4-9-3v-5c0-6%201-7%203-7l6-2%2013-5%201-8V8c0-2-3-2-21-2l-21%201m-20%2030v1l1%201h-2c-2%200-3%200-3%203v4c3%200%202%204%200%206-3%201-3%205-1%206l1-1%202-3c1-1%202-2%201-4l4-6c4-5%204-5%203-7h-6m10%201c-3%203-2%204%200%203l5-1c1%201%201%201-2%203h-5c-1%200-2%203-1%205%200%201%205%201%206-1h1l2%201%202-1h1c0%201%203%201%204-1%202-2%202-2%200-5-4-4-10-6-13-3m-3%2021l-1%201-2%208-1%202%201%203c-2-1-2%200-1%208%201%2013%201%2017-1%2016l-1%201v1l-1-3v-2l-1%202c-1%203%200%206%204%209%205%203%2019%208%2019%207h2c2%202%203%202%206%200s4-7%202-8-3-12-2-14l1-1v-2l3-1c1%201%203-3%202-4l-17-1-1-1%206-1c7-1%2012-4%206-4l-7-1h-4l-2%201c-1-2%202-3%2010-4%208%200%209%200%206-3-3-4-7-4-10-2l-4%202-3%204c-3%204-3%204-5%200-1-4-1-7%202-9l1-1c-3-2-6-4-7-3m-32%2077v10l44%201h44v-12h-44l-44%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/0f64de26879cdf31cf26870f568e20cd/ca0a1/i-RyIvtI.webp 223w", "/static/0f64de26879cdf31cf26870f568e20cd/75680/i-RyIvtI.webp 445w", "/static/0f64de26879cdf31cf26870f568e20cd/8d1ba/i-RyIvtI.webp 890w", "/static/0f64de26879cdf31cf26870f568e20cd/3838e/i-RyIvtI.webp 1335w", "/static/0f64de26879cdf31cf26870f568e20cd/e11e5/i-RyIvtI.webp 1780w", "/static/0f64de26879cdf31cf26870f568e20cd/bf2ca/i-RyIvtI.webp 2724w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/0f64de26879cdf31cf26870f568e20cd/e92b6/i-RyIvtI.png 223w", "/static/0f64de26879cdf31cf26870f568e20cd/e66bf/i-RyIvtI.png 445w", "/static/0f64de26879cdf31cf26870f568e20cd/4ef49/i-RyIvtI.png 890w", "/static/0f64de26879cdf31cf26870f568e20cd/4e814/i-RyIvtI.png 1335w", "/static/0f64de26879cdf31cf26870f568e20cd/701e9/i-RyIvtI.png 1780w", "/static/0f64de26879cdf31cf26870f568e20cd/3c9d8/i-RyIvtI.png 2724w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/0f64de26879cdf31cf26870f568e20cd/4ef49/i-RyIvtI.png",
              "alt": "i RyIvtI",
              "title": "i RyIvtI",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></a></p>
    <p><a parentName="p" {...{
        "href": "mailto:hello@xiaoru.li"
      }}><strong parentName="a">{`Xiaoru`}</strong></a>{` had the best cover letter I have ever seen and he built an amazing Pomodoro timer. Looked great, worked great, tugged at my heart strings. Loved some of the older projects he built as well.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/05b0000c1b18ec52ba5b9cde1e674d11/a2b91/i-TXCXG5.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "41.25560538116592%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'166\\'%20viewBox=\\'0%200%20400%20166\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M160%2039v4h26v-9h-26v5m45%2019c-4%202-3%2011%202%2012l3-2%202-2%201%202c3%205%208%202%208-5-1-5-4-7-7-3-2%202-3%202-3%201%200-3-3-4-6-3m-24%2027v5c0%202%201%203%209%203h8v-9h-8l-9%201m18%200v5l1%203h18v-9h-9l-10%201m-12%2015v3h26v-7h-26v4\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/05b0000c1b18ec52ba5b9cde1e674d11/ca0a1/i-TXCXG5.webp 223w", "/static/05b0000c1b18ec52ba5b9cde1e674d11/75680/i-TXCXG5.webp 445w", "/static/05b0000c1b18ec52ba5b9cde1e674d11/8d1ba/i-TXCXG5.webp 890w", "/static/05b0000c1b18ec52ba5b9cde1e674d11/3838e/i-TXCXG5.webp 1335w", "/static/05b0000c1b18ec52ba5b9cde1e674d11/e11e5/i-TXCXG5.webp 1780w", "/static/05b0000c1b18ec52ba5b9cde1e674d11/1ab77/i-TXCXG5.webp 3360w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/05b0000c1b18ec52ba5b9cde1e674d11/e92b6/i-TXCXG5.png 223w", "/static/05b0000c1b18ec52ba5b9cde1e674d11/e66bf/i-TXCXG5.png 445w", "/static/05b0000c1b18ec52ba5b9cde1e674d11/4ef49/i-TXCXG5.png 890w", "/static/05b0000c1b18ec52ba5b9cde1e674d11/4e814/i-TXCXG5.png 1335w", "/static/05b0000c1b18ec52ba5b9cde1e674d11/701e9/i-TXCXG5.png 1780w", "/static/05b0000c1b18ec52ba5b9cde1e674d11/a2b91/i-TXCXG5.png 3360w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/05b0000c1b18ec52ba5b9cde1e674d11/4ef49/i-TXCXG5.png",
              "alt": "i TXCXG5",
              "title": "i TXCXG5",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p><a parentName="p" {...{
        "href": "mailto:hsribei.pub@gmail.com"
      }}><strong parentName="a">{`Helder`}</strong></a>{` built a cool recursion visualizer that shows before your eyes how you can use React context instead of prop drilling to make your life easier. Said it helped him explain stuff to his dad who is learning how to code. Wow.`}</p>
    <p><a parentName="p" {...{
        "href": "https://codesandbox.io/s/3vmrlm0175"
      }}><span parentName="a" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px",
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "86.09865470852019%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'344\\'%20viewBox=\\'0%200%20400%20344\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%2017v18h200l200-1%201-18V0H0v17m164%20155v3h95v-7h-95v4m60-1c0%202%201%203%2017%203s17-1%2017-3v-2h-34v2m-60%2057v3h95v-7h-95v4m60-1c0%202%201%203%2017%203s17-1%2017-2c0-2-1-3-17-3h-17v2\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/2183f2840515e74ce3bde7e385678724/ca0a1/i-s14tMy.webp 223w", "/static/2183f2840515e74ce3bde7e385678724/75680/i-s14tMy.webp 445w", "/static/2183f2840515e74ce3bde7e385678724/8d1ba/i-s14tMy.webp 890w", "/static/2183f2840515e74ce3bde7e385678724/3838e/i-s14tMy.webp 1335w", "/static/2183f2840515e74ce3bde7e385678724/e11e5/i-s14tMy.webp 1780w", "/static/2183f2840515e74ce3bde7e385678724/f6456/i-s14tMy.webp 2718w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/2183f2840515e74ce3bde7e385678724/e92b6/i-s14tMy.png 223w", "/static/2183f2840515e74ce3bde7e385678724/e66bf/i-s14tMy.png 445w", "/static/2183f2840515e74ce3bde7e385678724/4ef49/i-s14tMy.png 890w", "/static/2183f2840515e74ce3bde7e385678724/4e814/i-s14tMy.png 1335w", "/static/2183f2840515e74ce3bde7e385678724/701e9/i-s14tMy.png 1780w", "/static/2183f2840515e74ce3bde7e385678724/e7ee0/i-s14tMy.png 2718w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/2183f2840515e74ce3bde7e385678724/4ef49/i-s14tMy.png",
              "alt": "i s14tMy",
              "title": "i s14tMy",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></a></p>
    <p><a parentName="p" {...{
        "href": "mailto:shawnhosea@shawnhosea.com"
      }}><strong parentName="a">{`Shawn`}</strong></a>{` built a neat newsletter sign up form with an animated background. A little forced for a React context example, but I like how it looks, and he seems cool.`}</p>
    <p><a parentName="p" {...{
        "href": "https://craftatoms.github.io/newslettertemplate/"
      }}><span parentName="a" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px",
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "44.39461883408072%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'177\\'%20viewBox=\\'0%200%20400%20177\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%2089v88h401V0H0v89m153-21v3h75v-7h-75v4\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/d95a8cb87f1b4dd8e5a2e93aa9c1ae08/ca0a1/i-jEL88f.webp 223w", "/static/d95a8cb87f1b4dd8e5a2e93aa9c1ae08/75680/i-jEL88f.webp 445w", "/static/d95a8cb87f1b4dd8e5a2e93aa9c1ae08/8d1ba/i-jEL88f.webp 890w", "/static/d95a8cb87f1b4dd8e5a2e93aa9c1ae08/3838e/i-jEL88f.webp 1335w", "/static/d95a8cb87f1b4dd8e5a2e93aa9c1ae08/e11e5/i-jEL88f.webp 1780w", "/static/d95a8cb87f1b4dd8e5a2e93aa9c1ae08/8bd77/i-jEL88f.webp 6016w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/d95a8cb87f1b4dd8e5a2e93aa9c1ae08/e92b6/i-jEL88f.png 223w", "/static/d95a8cb87f1b4dd8e5a2e93aa9c1ae08/e66bf/i-jEL88f.png 445w", "/static/d95a8cb87f1b4dd8e5a2e93aa9c1ae08/4ef49/i-jEL88f.png 890w", "/static/d95a8cb87f1b4dd8e5a2e93aa9c1ae08/4e814/i-jEL88f.png 1335w", "/static/d95a8cb87f1b4dd8e5a2e93aa9c1ae08/701e9/i-jEL88f.png 1780w", "/static/d95a8cb87f1b4dd8e5a2e93aa9c1ae08/76585/i-jEL88f.png 6016w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/d95a8cb87f1b4dd8e5a2e93aa9c1ae08/4ef49/i-jEL88f.png",
              "alt": "i jEL88f",
              "title": "i jEL88f",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></a></p>
    <h2 {...{
      "id": "how-i-picked"
    }}>{`How I picked`}</h2>
    <p>{`Ranking people is strange and weird, and it took me a long time to not make a choice in the end. I hired both Shawn and Helder.`}</p>
    <p>{`Best way to see who you wanna work with is to work with them for a little and see what's up. Right?`}</p>
    <p>{`My stated goal was to pick based on slope – how fast they learn. I did my best to follow that principle, but human factors came into play, too.`}</p>
    <p>{`Shawn is the most excited person about React I've ever seen, and Helder has a lot of professionalism. Xiaoru looked amazing, but he's still in school, and I remember what freelancing was like when I was still in school. Balls got dropped.`}</p>
    <p>{`I'm gonna be dropping plenty of balls on my own! I don't want the people helping me dropping them, too :D`}</p>
    <p><img parentName="p" {...{
        "src": "/d4c88b8cc620af6af67c33910899fcf7/wikipedia-commons-c-c8-Bubble-sort-example-300px.gif",
        "alt": "Bubble sort"
      }}></img></p>
    <p>{`Oh, and I used `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Bubble_sort"
      }}>{`bubble sort`}</a>{`. Bubble sort is great. Instead of looking at a heap of people and being overwhelmed, you compare 2 at a time. It's easier to decide that way and eventually the best bubble up to the top.`}</p>
    <p>{`Need some help building your side projects or whatnot? Consider the folks above! Each name links to their email. They'd love to help!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      